module.exports = __webpack_public_path__ + "img/notifications.15887b63.svg";